import { Method, Request, sendRequest } from "@myloc/myloc-utils";
import { api } from "../../config/settings";
import defaultRestOptions from "../utils/defaultRestOptions";

async function getSearch(searchValue: string) {
  const url = api.search.search();

  url.addParameter("search", searchValue);

  const request = new Request(url, Method.GET);

  return await sendRequest(request, {}, await defaultRestOptions());
}

export default {
  getSearch,
};
